import * as _ from 'lodash'
import { ObjectParser } from '../ObjectParser';

export interface IDataSourceRequestInit extends RequestInit {
  recordsPath: string
  visualizationPath: string
}

export type DataSourceSortOrderTypes = 'asc' | 'desc' | ''

export class DataSource<T, U> {
  protected sortBy = ''
  protected sortIndex = ''
  protected sortOrder: DataSourceSortOrderTypes = ''
  private records: T[]
  private visualization: U
  private listeners: Array<(records: T[], visualization: U) => void> = []
  private debounceSync = _.debounce(() => this.updateListeners(), 25)
  private dataFetch: Promise<void>

  constructor(
    private requestUrl: string,
    private requestInit: IDataSourceRequestInit
  ) {/**/ }

  getSortIndex() {
    return this.sortIndex
  }

  getSortOrder() {
    return this.sortOrder
  }

  setSorting(sortIndex: string, sortOrder: DataSourceSortOrderTypes, sortBy?: string): this {
    this.sortIndex = sortIndex
    this.sortOrder = sortOrder
    this.sortBy = sortBy ? sortBy : sortIndex

    return this
  }

  onSync(listener: (records: T[], visualization: U) => void, immediate = true) {
    this.listeners.push(listener)

    if (immediate && Array.isArray(this.records)) {
      listener(this.records, this.visualization)
    }

    return () => {
      const listenerIndex = this.listeners.indexOf(listener)

      if (listenerIndex >= 0) {
        this.listeners.splice(listenerIndex, 1)
      }
    }
  }

  sync(): this {

    this.loadData().then(() => {
      if (this.sortIndex) {
        this.sort(this.comparator.bind(this))
        //if (this.sortOrder === 'asc') {
        this.records = this.records.reverse()
        //}
      } else { this.debounceSync() }
    })

    return this
  }

  sort(compareFn: ((a: T, b: T) => number)): this {
    this.loadData().then(() => {
      this.records.sort(compareFn)

      this.debounceSync()
    })

    return this
  }

  protected updateListeners() {
    this.listeners.forEach((listener) => {
      if (typeof listener === 'function') {

        listener(this.records, this.visualization)
      }
    })
  }

  protected loadData() {
    if (!this.dataFetch) {
      this.dataFetch = fetch(this.requestUrl, this.requestInit)
        .then((res) => res.json())
        .then((jsonRes) => {
          this.records = _.get(jsonRes, this.requestInit.recordsPath)
          this.visualization = _.get(jsonRes, this.requestInit.visualizationPath)
        })
    }

    return this.dataFetch
  }

  protected comparator(d1: T, d2: T): number {
    if (!this.sortIndex) {
      throw new Error('sortIndex is not defined')
    }

    const isDescending = this.sortOrder === 'desc'
    const c1 = ObjectParser.QueryAndGetFirst(d1, this.sortIndex)
    const c2 = ObjectParser.QueryAndGetFirst(d2, this.sortIndex)
    const c1IsDefined = typeof c1 !== 'undefined' && c1 !== null
    const c2IsDefined = typeof c2 !== 'undefined' && c2 !== null

    if (c1IsDefined && c2IsDefined) {
      if (c1 > c2) {
        return isDescending ? 1 : -1
      } else if (c2 > c1) {
        return isDescending ? -1 : 1
      }
    } else if (c1IsDefined) {
      return isDescending ? 1 : -1
    } else if (c2IsDefined) {
      return isDescending ? -1 : 1
    }

    return 0
  }

}
